import { vehicleInventoryReturnData } from './fragments'

export const updateVehicleInventoryMutation = `#graphql
mutation LIB_updateVehicleInventory($innodbInventoryid: UInt!, $part: InventoryUpdate!) {
	part: updateInventory(id:$innodbInventoryid, input: $part) {
		${vehicleInventoryReturnData}
	}
}`

export const newVehicleInventoryMutation = `#graphql
mutation LIB_newVehicleInventory($part: NewStandardInventory!) {
	part: createStandardInventory(input: $part) {
		${vehicleInventoryReturnData}
	}
}`
